import React from 'react';
import classNames from 'classnames';
import { string as stringProp } from 'prop-types';
import { params, string, shape, useDataModel } from '@thd-nucleus/data-sources';
import { Typography } from '@one-thd/sui-atomic-components';
import { DUAL_PATH_IDENTIFIER } from '../../utils';

export const ProductServiceAddOns = ({ itemId }) => {
  const { data } = useDataModel('product', {
    variables: {
      itemId,
    }
  });

  const productSubTypeName = data?.product?.info?.productSubType?.name;
  const isDualPathSku = productSubTypeName === DUAL_PATH_IDENTIFIER;

  const addOnsClasses = classNames({
    'sui-flex sui-w-full sui-p-1': isDualPathSku,
    'sui-hidden': !isDualPathSku,
  });

  return (
    <div className={addOnsClasses}>
      <Typography variant="body-xs" weight="bold">
        Expert Installation Available
      </Typography>
    </div>

  );
};
ProductServiceAddOns.propTypes = {
  itemId: stringProp.isRequired,
};

ProductServiceAddOns.dataModel = {
  product: params({
    itemId: string().isRequired(),
  }).shape({
    itemId: string(),
    dataSources: string(),
    info: shape({
      productSubType: shape({
        name: string(),
      }),
    }),
  }),
};

ProductServiceAddOns.displayName = 'ProductServiceAddOns';